export const dynamicPricing = {
  title: "التسعير الديناميكي",
  loading: "جارٍ تحميل الإعدادات…",
  status: {
    active: "مُفعّل",
    inactive: "مُعطّل",
  },
  close: "إغلاق",
  unit: {
    label: "مكان الإقامة",
    autoPill: "✦ تلقائي من سجلّك",
  },
  tabs: {
    calendario: "التقويم",
    precio: "السعر الأساسي",
    reglas: "القواعد",
    aplicacion: "التطبيق",
  },
  weekdaysShort: {
    mon: "الاثنين",
    tue: "الثلاثاء",
    wed: "الأربعاء",
    thu: "الخميس",
    fri: "الجمعة",
    sat: "السبت",
    sun: "الأحد",
  },
  cal: {
    stats: {
      adr: "متوسط السعر المتوقع",
      occupancy: "الإشغال",
      revenue: "الإيرادات",
    },
    calculating: "جارٍ حساب الأسعار…",
    minStayShort: "أدنى {count}ل | أدنى {count}ل",
  },
  legend: {
    low: "منخفض",
    base: "أساسي",
    high: "مرتفع",
    peak: "ذروة",
    booked: "محجوز",
    override: "ثابت",
  },
  why: {
    title: "لماذا {price} {curr} · {day}",
    chip: "شرح",
    nights: "{count} ليلة | {count} ليالٍ",
    minStay: "الحد الأدنى للإقامة: {nights} · الحد الأدنى {floor} / الحد الأقصى {ceil} {curr}",
    hint: "اضغط على يوم لعرض تفاصيل سعره.",
  },
  apply: {
    diffPrefix: "بالأسعار المقترحة:",
    diffSuffix: "مقارنةً بأسعارك الحالية لشهر {month}.",
    apply: "تطبيق الأسعار",
    applying: "جارٍ التطبيق…",
    applyNow: "طبّق الآن",
    enableToApply: "فعّل التسعير الديناميكي للتطبيق.",
    enableFirst: "فعّل التسعير الديناميكي أولاً.",
    autoNote: {
      prefix: "✓ في الوضع",
      mode: "التلقائي",
      mid: "تُطبَّق الأسعار",
      everyday: "كل يوم",
    },
    result: {
      hotelPending: "الفنادق (وحدات متعددة) غير مدعومة بعد في هذه المرحلة.",
      ok: "✓ تم تطبيق {count} يوم ({from} → {to}) وإرساله إلى القنوات. | ✓ تم تطبيق {count} أيام ({from} → {to}) وإرسالها إلى القنوات.",
      failed: "تعذّر تطبيق الأسعار.",
    },
  },
  base: {
    title: "السعر الأساسي والحدود",
    desc: "مقترحة من سجلّك. لا يتجاوز المحرّك هذا النطاق أبدًا.",
    basePerNight: "الأساسي / الليلة",
    min: "الحد الأدنى (الأرضية)",
    max: "الحد الأقصى (السقف)",
    rounding: "التقريب",
  },
  rounding: {
    integer: "صحيح",
    ends0: "ينتهي بـ 0",
    ends9: "ينتهي بـ 9",
    multiple5: "مضاعفات 5",
  },
  weekend: {
    title: "نهاية الأسبوع والحد الأدنى للإقامة",
    upliftLabel: "زيادة نهاية الأسبوع",
    daysLabel: "أيام نهاية الأسبوع:",
    minStayLabel: "الحد الأدنى للإقامة (ليالٍ)",
    minStayNormal: "عادي",
    minStayWeekend: "نهايات الأسبوع / الموسم المرتفع",
    orphanTitle: "ملء الليالي المعزولة",
    orphanDesc: "إقامات أقصر (خصم {pct}%) في فجوات 1–2 ليلة.",
  },
  demand: {
    title: "الحساسية للطلب",
    desc: "مدى تأثير الإشغال ووتيرة الحجوزات على السعر.",
  },
  aggr: {
    low: "متحفّظ",
    medium: "متوسط",
    high: "جريء",
  },
  seasons: {
    title: "المواسم",
    namePlaceholder: "الاسم",
    monthDayPlaceholder: "MM-DD",
    add: "+ إضافة موسم",
  },
  events: {
    title: "الفعاليات (معارض، مهرجانات…)",
    suggestWithAI: "✨ اقترِح بالذكاء الاصطناعي",
    suggesting: "جارٍ البحث…",
    namePlaceholder: "الاسم",
    datePlaceholder: "YYYY-MM-DD",
    empty: "لا توجد فعاليات. أضِفها يدويًا أو بالذكاء الاصطناعي.",
    add: "+ إضافة فعالية",
    suggestionsHead: "اقتراحات الذكاء الاصطناعي{city} — راجِع التواريخ وأضِف",
    addSuggestion: "+ إضافة",
    noSuggestions: "لا توجد اقتراحات (تأكّد من ضبط مدينة مكان الإقامة).",
  },
  demandRules: {
    title: "قواعد الطلب",
    lastMinuteTitle: "خصومات اللحظة الأخيرة",
    lastMinuteDesc: "يخفّض سعر التواريخ القريبة التي ما زالت متاحة.",
    holidaysTitle: "العطلات التلقائية",
    holidaysDesc: "يطبّق +{pct}% في العطلات الوطنية.",
    occupancyTitle: "الرفع حسب الإشغال",
    occupancyDesc: "إذا تجاوز إشغال الشهر {threshold}%، ارفع السعر.",
    weeklyDiscount: "خصم أسبوعي (7+) %",
    monthlyDiscount: "خصم شهري (28+) %",
  },
  application: {
    title: "الوضع والمزامنة",
    modeLabel: "وضع التطبيق",
    modeSuggested: "مقترَح (أراجع أولاً)",
    modeAuto: "تلقائي",
    syncTitle: "المزامنة مع القنوات (Channex → Airbnb / Booking)",
    syncDesc: "ينشر الأسعار المحسوبة على قنواتك.",
    horizonLabel: "أفق الحساب",
    horizonMonths: "{count} شهرًا",
  },
  save: {
    saved: "تم الحفظ ✓",
    saving: "جارٍ الحفظ…",
    save: "حفظ التغييرات",
  },
  errors: {
    forbidden: "ليس لديك صلاحية الوصول إلى مكان الإقامة هذا.",
    loadFailed: "تعذّر تحميل الإعدادات.",
    saveFailed: "تعذّر الحفظ. تحقّق من الحقول.",
  },
};
